import { FeatureFlags } from 'utils/featureFlags';
import useFeatureFlag from './useFeatureFlag';

export function useV2VariableRoutesFlag(): boolean {
  const flags = useFeatureFlag([FeatureFlags.v2VariableRoutes]);
  return flags[FeatureFlags.v2VariableRoutes] === true;
}
